/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import $ from 'jquery';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';
import metadata from '../block.json';
/**
 * Internal dependencies
 */
import Edit from './edit';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
 if (oer_subject_resources.version_58==1){
    registerBlockType( metadata, {
        edit: Edit,
    });
 } else {
    registerBlockType( 'oer-block/subject-resources-block', {
    /**
     * This is the display title for your block, which can be translated with `i18n` functions.
     * The block inserter will show this name.
     */
    title: __( 'WP OER Subject Resources Block', 'oer-subject-resources-block' ),


    /**
     * This is a short description for your block, can be translated with `i18n` functions.
     * It will be shown in the Block Tab in the Settings Sidebar.
     */
    description: __( 'Displays list of resources according to subject areas.', 'oer-subject-resources-block' ),

    /**
     * Blocks are grouped into categories to help users browse and discover them.
     * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
     */
    category: 'oer-block-category',

    /**
     * An icon property should be specified to make it easier to identify a block.
     * These can be any of WordPress’ Dashicons, or a custom svg element.
     */
    icon: {
        foreground: '#121212',
        src: 'welcome-widgets-menus'
    },

    keywords: [__('OER', 'oer-subject-resources-block'), __('Resource', 'oer-subject-resources-block'), __('Subject Areas', 'oer-subject-resources-block')],

    attributes : {
        content: {
            type: 'string',
            selector: 'p'
        },
        title: {
            type: 'string',
            selector: 'h2'
        },
        link: {
            type: 'string',
            selector: 'a'
        },
        displayCount: {
            type: 'string',
            selector: 'display-count',
            default: 5
        },
        selectedSubject: {
            type: 'number',
            default: 0
        },
        sort: {
            type: 'string',
            selector: 'sort-option',
            default: "modified"
        },
        selectedSubjectResources: {
            type: 'array'
        },
        subjects: {
            type:'array'
        }, 
        selectedSubjects: {
            type:'array'
        },
        childSubjects: {
            type:'array'
        }, 
        isChanged: {
            type: 'boolean',
            default: false
        },
        blockId: {
            type: 'string'
        },
        firstLoad: {
            type: 'boolean',
            default: true
        }
    },

     /**
      * @see ./edit.js
      */
     edit: Edit,

     /**
      * @see ./save.js
      */
     //save,
    } );
 }
